module.exports = __webpack_public_path__ + "static/media/scan_again.481a1657.svg";